<ng-template #defaultItemTemplate let-item="item">
    <app-list-item-user [member]="item" [truncateLimit]="pwaService.isMobile ? TRUNCATE_LIMIT_MOBILE : TRUNCATE_LIMIT_DESKTOP"></app-list-item-user>
</ng-template>
<ul #list [hidden]="hidden" class="dropdown-menu scrollable-menu" [class.mention-menu]="!styleOff" [class.mention-dropdown]="!styleOff && dropUp">
    <li ng-class="{ 'no-click': clickable }" class="mention-title">Membres</li>
    <li
        *ngFor="let item of items; let i = index"
        [class.active]="activeIndex == i"
        [class.mention-active]="!styleOff && activeIndex == i"
        class="p-mb-0"
    >
        <a class="mention-dropdown" [class.mention-item]="!styleOff" (mousedown)="activeIndex = i; itemClick.emit(); $event.preventDefault()">
            <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
        </a>
    </li>
</ul>
